// Importaciones de React, hooks y componentes.
import React, { useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom"; // Hook para acceder a la información de la URL.
import BannerServicios from "../component/BannerServicios"; // Banner principal de la página de servicios.
import Consultoria from "../component/Consultoria"; // Sección de consultoría.
import Ciberseguridad from "../component/Ciberseguridad"; // Sección de ciberseguridad.
import Casos from "../component/Casos"; // Sección de casos de éxito/uso.
import InteligenciaArtificial from "../component/InteligenciaArtificial"; // Sección de IA.
import Valores from "../component/Valores"; // Sección de valores.
import Recursos from "../component/Recursos"; // Sección de recursos.

// import Plataforma from "../component/Plataforma"; // Componente no utilizado actualmente.

/**
 * Componente de la página de Servicios.
 * Organiza y muestra las diferentes secciones de servicios que ofrece la empresa.
 * Incluye una funcionalidad para hacer scroll automático a una sección si se especifica en la URL (ej. /servicios#ciberseguridad).
 */
export const Servicios = () => {
  // `location` contiene la información de la ruta actual, incluyendo el hash (#).
  const location = useLocation();

  /**
   * Función para hacer scroll suave a un elemento del DOM por su ID.
   * @param {string} sectionId - El ID del elemento al que se quiere desplazar.
   * @param {number} offset - Un desplazamiento vertical en píxeles para ajustar la posición final del scroll.
   */
  const scrollToSection = useCallback((sectionId, offset = 100) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // Calcula la posición del elemento y le resta el offset.
      const y = section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: "smooth" }); // Realiza el scroll suave.
    }
  }, []); // `useCallback` memoriza la función para evitar que se recree en cada renderizado.

  // Efecto que se ejecuta cuando cambia la `location` (navegación) o se crea `scrollToSection`.
  useEffect(() => {
    // Lista de IDs de secciones válidas para el scroll.
    const validSections = ['ciberseguridad', 'consultoria', 'ia', 'casos', 'valores', 'recursos'];
    // Extrae el ID de la sección del hash de la URL (ej. de "#ciberseguridad" a "ciberseguridad").
    const targetSection = location.hash.replace('#', '');

    // Si el ID extraído es válido, llama a la función de scroll.
    if (validSections.includes(targetSection)) {
      scrollToSection(targetSection);
    }
  }, [location, scrollToSection]); // Dependencias del efecto.

  return (
    <div className="servicios-container">
      {/* Renderiza el banner principal de la página. */}
      <BannerServicios />

      {/* Cada <section> envuelve un componente de servicio y tiene un ID
          que corresponde a los hashes de la URL para permitir el scroll. */}

      <section id="consultoria">
        <Consultoria />
      </section>

      <section id="ciberseguridad" className="section-spacing">
        <Ciberseguridad />
      </section>

      <section id="ia">
        <InteligenciaArtificial />
      </section>

      <section id="casos">
        <Casos />
      </section>

      <section id="valores">
        <Valores />
      </section>

      <section id="recursos">
        <Recursos />
      </section>
    </div>
  );
}

// Exporta el componente para ser usado por el enrutador.
export default Servicios;
